interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`mb-7 flex flex-col ${alignment} md:mb-9`}>
      {kicker && (
        <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-800">
          <i className="ri-leaf-line text-sm" aria-hidden="true"></i>
          {kicker}
        </span>
      )}
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}